'use strict';
import editorialVideos from '../components/editorialVideos';
import plugins from '../components/plugins';

var filterSidebar = document.getElementById('desktopFilterSidebar');
var mobileAccordionState = [];
var scrollAnimate = require('../components/scrollAnimate');
var stickySidebar;
var stickySidebarConfigs = {
    topSpacing: 60,
    resizeSensor: true
};
var stickySidebarInitialHeight = 0;

var GtmEvents = require('../seo/gtm/gtmEvents');

/**
 * Handle desktop and tablet/mobile collapses closing in refinement bar
 * @param {Object} e - The Event interface
 */

function closeRefinementsAccordion (e) {
    let openCollapses = $(e.target).closest('.sticky-sidebar-container').find('.collapse.show');

    openCollapses.each((index, el) => {
        let openCollapseid = $(el).attr('id');
        let openCollapseButton = $(`button[data-toggle="collapse"][data-target="#${openCollapseid}"]`);

        $(el).collapse('hide');
        openCollapseButton.addClass('collapsed');
        openCollapseButton.attr('aria-expanded', 'false');

    });
}

/**
 * On mobile and tablet devices, check whether a category is checked or not.
 * The function is then used to check/uncheck the radio button related to the clicked category or
 * trigger a second ajax call with the checked category as target when
 * an attribute or price refinement is checked and a category was already selected
 */

function isMobileCategoryChecked () {
    let isChecked = null;

    $('.sticky-sidebar .categoryRefinement').each((i, el) => {
        if ($(el).find('input').is(':checked')) {
            isChecked = $(el).closest('.categoryRefinement').attr('data-refinement-value');
        }
    });

    return isChecked;
}

/**
 * Get proper ajax href for the filter clicked.
 * @param {Object} currentFilter - The filter currently clicked
 * @return {Object} data-top-category-href if the user in on mobile/tablet devices and a category is unchecked
 * @return {Object} data-href in all the other cases
 */

function getRefinementHref (currentFilter) {

    if (!Breakpoints.is('lgUp') && currentFilter.hasClass('categoryRefinement') && currentFilter.find('input').is(':checked')) {
        return currentFilter.data('top-category-href');
    } else {
        return currentFilter.data('href');
    }
}

/**
 * Add a URL with filters, sort, and page size preserved to the browser's session history stack.
 */

function pushPermalink () {
    let permalink = $('.permalink').val();
    window.history.pushState({}, null, permalink);
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom ($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * On mobile and tablet devices, when an attribute or price refinement is selected and a category was already checked,
 * this utility function triggers a second ajax call with the checked category as target in order to restore
 * the previously checked category
 * @param {Object} $results - jQuery DOM element
 */
function updateMobileRefinementsOnAttributesAndPrices ($results) {
    let checkedMobileCategoryValue;

    if (isMobileCategoryChecked() && isMobileCategoryChecked().length > 0) {
        checkedMobileCategoryValue = isMobileCategoryChecked();
    }

    $('.sticky-sidebar .categoryRefinement').each((i, el) => {
        if ($(el).find('input').is(':checked')) {
            checkedMobileCategoryValue = $(el).closest('.categoryRefinement').attr('data-refinement-value');
        }
    });

    updateDom($results, '.refinements');

    if (checkedMobileCategoryValue && checkedMobileCategoryValue.length > 0) {
       $(`div.categoryRefinement[data-refinement-value="${checkedMobileCategoryValue}"]`).first().trigger('search:applyFilters');
    }
}

/**
 * On mobile and tablet devices, check/uncheck the selected category
 * @param {Object} currentMobileCategory - The current category being clicked
 */
function updateMobileRefinementsOnCategory (currentMobileCategory) {
    let currentMobileCategoryInput = currentMobileCategory.find('input');
    if (currentMobileCategoryInput.is(':checked')) {
        currentMobileCategoryInput.prop('checked', false);
    } else {
        currentMobileCategoryInput.prop('checked', true);
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements ($results, $currentElement) {

    if (!$currentElement.hasClass('categoryRefinement')) {
        // Update open collapses
        $results.find('.sticky-sidebar .collapse').removeClass('show');
        $results.find('.sticky-sidebar [data-toggle="collapse"]').addClass('collapsed');

        $('.sticky-sidebar .collapse').each(function (i, el) {
            if ($(el).hasClass('show')) {
                let elementID = $(el).attr('id');

                $results.find('.sticky-sidebar .collapse').eq(i).addClass('show');
                $results.find(`.sticky-sidebar [data-toggle="collapse"][data-target="#${elementID}"]`).removeClass('collapsed');
            }
        });
    }

    if (!Breakpoints.is('lgUp') && !$currentElement.hasClass('close-mobile-filters') && false) {
        if ($currentElement.hasClass('categoryRefinement')) { // With the restyle these specific handler cause a bug with the radio button filer.
            updateMobileRefinementsOnCategory($currentElement); // I did not have much time so I excluded them.
        } else {
            updateMobileRefinementsOnAttributesAndPrices($results);
        }
    } else {
        updateDom($results, '.refinements');
    }
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults (response, $currentElement) {
    var $pushState = true;
    var $renderableElements = [
        //'#mobile-refinements-container',
        '.mobile-apply-filters-button',
        '#mobile-breadcrumbs',
        '#sort-order', // Desktop sort
        '#mobile-sort-order', // Mobile sort
        '.header-bar',
        '.header.page-title',
        '#search-results-details-header',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.breadcrumb-container',
    ];
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    if (Breakpoints.is('lgUp')) {
        //
        // On desktop devices, of if the 'View all filters' button is clicked on mobile and tablet devices,
        // render all the elements
        $('body').removeClass('mobile-filters-selected');

    } else if ($currentElement.hasClass('view-all-renderer')) {
        let viewAllRendererCount = parseInt($('.view-all-renderer-count').text(), 10);

        if (viewAllRendererCount == 0) {
            var $updates = $results.find('.results-count-ajax');
            $('.search-results').empty().html($updates.html());
        }

    } else if($currentElement.hasClass('close-mobile-filters')) {
        $pushState = true;
    } else {
        // On mobile and tablet devices, only specific elements (the one specified in the $renderableElements array below)
        // are updated rendered and immediately. All the other elements are updated and rendered on 'View All Filters'
        // button click only

        $('body').addClass('mobile-filters-selected');

        $pushState = false;

        if (!$currentElement.hasClass('categoryRefinement') && isMobileCategoryChecked() && isMobileCategoryChecked().length > 0) {
            $renderableElements = [];
        } else {
            $renderableElements = [
                '.mobile-apply-filters-button'/*,
                '#mobile-refinements-container' */
            ];
        }
    }

    // Update DOM elements that do NOT require special handling
    // Updatable DOM elements differ depending on desktop or mobile/tablet devices
    // See the comments above for more details
    $renderableElements.forEach(function (selector) {
        updateDom($results, selector);
    });

    // Update DOM elements which DO require special handling
    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results, $currentElement);
    });

    // Close mobile refinements panel if the 'View All Filters' button has been pressed
    // on mobile and tablet devices
    if (!Breakpoints.is('lgUp') && $currentElement.hasClass('view-all-renderer')) {
        $('body').trigger('search:closeMobileRefinements');
    }

    if ($pushState) {
        pushPermalink();
    }
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent ($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Send Analytics data when applying a filter
 * @param {Object} e - The Event interace
 */

function sendFilterDataGtmEvent (e) {
    let refinementType = $(e.currentTarget).data('refinement-type');
    let refinementValue = $(e.currentTarget).data('refinement-value');

    if ($(e.currentTarget).is('li') && !$(e.currentTarget).find('input').is(':checked')) {
        // Attributes and prices refinements
        GtmEvents.filterData(refinementType, refinementValue);
    } else if ($(e.currentTarget).hasClass('categoryRefinement')) {
        // Category refinements
        GtmEvents.filterData(refinementType, refinementValue);
    }
}

/**
 * Update selected sorted option on mobile and tablet devices
 */

function updateSelectedSortOption () {
    let sortRuleID = $('.grid-footer').data('sort-options').ruleId;

    // Desktop
    $('.sort-order-panel').find('button:not([data-toggle="collapse"])').removeClass('font-weight-bold');
    $('.sort-order-panel').find(`button.${sortRuleID}`).addClass('font-weight-bold');

    // Tablet & mobile
    $('#mobile-sort-order').find('input').removeAttr('checked');
    $('#mobile-sort-order').find('.custom-control-label').removeClass('font-weight-bold');

    $('#mobile-sort-order').find(`.${sortRuleID} input`).attr('checked', 'checked');
    $('#mobile-sort-order').find(`.${sortRuleID} .custom-control-label`).addClass('font-weight-bold');
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions (response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;

    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Force recalculation of Sticky Sidebar cached attributes after key events,
 * such as refinement or sorting ajax call or show more content actions
 */
function updateStickySidebarDimensions () {
    // Update Sticky Sidebar. The public method updateSticky() does not work
    if(Breakpoints.is('lgUp')) {
       stickySidebar.destroy();
       stickySidebar = new StickySidebar (filterSidebar, stickySidebarConfigs);
    }
}

class Search {
    changeLayout () {
        $('body').on('click', '.change-view', () => {
            $('.product-tiles-grid').toggleClass('grid');
            $('.default-view-button, .change-view-button').toggleClass('d-none');
        });
    }

    closeMobileRefinements () {
        // Refinements close button
        $('body').on('search:closeMobileRefinements', () => {
            $('#mobile-refinements, #mobile-sort-order').collapse('hide').removeClass('show');
            $('body').removeClass('mobile-refinements-active');
            mobileAccordionState = [];
        });

        $('body').on('click', '.mobile-apply-filters-button .close-mobile-filters', (e) => {
            e.preventDefault();
            e.stopPropagation();

            let $currentElement = $(e.currentTarget);
            let totalFiltersApplied = parseInt($('.mobile-total-filters-count').text(), 10);

            if (totalFiltersApplied > 0) {
                let urlHref = $('.ajaxBaseURL').val();

                $.veil().start();

                $.ajax({
                    url: urlHref,
                    method: 'GET',
                    success: function (response) {
                        parseResults(response, $currentElement);
                        scrollAnimate(null, 0);
                        $.veil().stop();
                        $('body').trigger('search:closeMobileRefinements');
                    },
                    error: function () {
                        $.veil().stop();
                    }
                });
            } else {
                $('body').trigger('search:closeMobileRefinements');
            }

        });
    }

    desktopFilterSidbarOpen () {
        $('#filter-toggle-button').on('click', (e) => {
            let h = document.querySelector('header').offsetHeight;
            $('#desktop-refinement-container').css('top', h); //Set top of the filter container, so it will stick right under the header
            stickySidebarInitialHeight = h;
            //$('#desktop-refinement-container').toggleClass('d-none');
        });
    }

    desktopFilterSidbarClose () {

        $('body').on('search:closeDesktopRefinements', () => {
            //$('#desktop-refinement-container').toggleClass('d-none');
            $('body').removeClass('mobile-refinements-active');
            mobileAccordionState = [];
        });
        $('.close-refinements-btn').on('click', () => {
            $('body').trigger('search:closeDesktopRefinements')
        });
    }

    desktopStickyFilterSidebar () {

        let lgUp = Breakpoints.get('lgUp');

        // Enable Sticky Sidebar on desktop devices
        lgUp.on('enter', () => {
            stickySidebar = new StickySidebar (filterSidebar, stickySidebarConfigs);
        });

        // Destroy Sticky Sidebar on mobile and tablet devices
        lgUp.on('leave', () => {
            stickySidebar.destroy();
        });

        $(window).on('scroll', (e) => {
            let refinementContainer = document.getElementById('refinments-container');
            let refinementAnchor = document.getElementById('desktop-refinement-container');
            let footer = document.querySelector('footer');
            if (footer.getBoundingClientRect().top < refinementContainer.getBoundingClientRect().bottom) {
                let h = parseInt(refinementAnchor.style.top, 10) - (refinementContainer.getBoundingClientRect().bottom - footer.getBoundingClientRect().top);
                $('#desktop-refinement-container').css('top', h);
            } else {
                if (parseInt(refinementAnchor.style.top, 10) < parseInt(stickySidebarInitialHeight) - 1) {
                    let h = parseInt(refinementAnchor.style.top, 10) - (refinementContainer.getBoundingClientRect().bottom - footer.getBoundingClientRect().top);
                    $('#desktop-refinement-container').css('top', h);
                } else {
                    $('#desktop-refinement-container').css('top', stickySidebarInitialHeight);
                }
            }
        });

    }

    gtmSendSearchData () {
        var resultsCount = $('#search-container').data('results-count');
        GtmEvents.sendSearchData(resultsCount);
    }

    gtmSendProductClick () {
        // send data to dataLayer when click a product
        $('body').on('click', '.gtm-product-click', function () {
            var items = [];
            var product = {};
            var currency = $(this).attr('data-currency');
            var list = $(this).attr('data-category');

            product.name = $(this).attr('data-productname');
            product.id = $(this).attr('data-id');
            product.price = $(this).attr('data-price');
            product.brand = $(this).attr('data-brand');
            product.category = $(this).attr('data-category');
            //product.variant = productContainer.attr('data-variant');
            product.position = $(this).parents('[data-index]').data('index');
            items.push(product);
            GtmEvents.sendProductClickData(currency, items, list);
        });
    }

    sort () {
        // Handle sort order menu selection
        $('body').on('click', '#sort-order button, #mobile-sort-order button, .mobile-sort-option', function (e) {
            e.preventDefault();

            $('#sort-order, #mobile-sort-order').collapse('hide');
            var sortOrderValue = $(this).data('refinement-value');
            var url = $(this).data('href');

            Breakpoints.is('lgUp') ? $.spinner().start() : $.veil().start();

            $(this).trigger('search:sort', url);
            $.ajax({
                url: url,
                data: {
                    selectedUrl: url
                },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    pushPermalink();
                    updateSelectedSortOption();
                    GtmEvents.listingOrder(sortOrderValue);
                    updateStickySidebarDimensions();

                    Breakpoints.is('lgUp') ? $.spinner().stop() : $.veil().stop();
                },
                error: function () {
                    Breakpoints.is('lgUp') ? $.spinner().stop() : $.veil().stop();
                },
                complete: function () {
                    $('body').trigger('search:closeMobileRefinements');
                }
            });
        });
    }

    showMore () {
        // Show more products
        $('.container-xxl').on('click', 'button.show-content', function (e) {
            e.stopPropagation();

            var loadContentMode = $('.search-results').data('load-content-mode');
            var showMoreUrl = $(this).data('url');

            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: {
                    selectedUrl: showMoreUrl
                },
                method: 'GET',
                success: function (response) {
                    switch (loadContentMode) {
                    case 'pagination':
                        $('.product-grid').empty().html(response);
                        scrollAnimate(null, 0);
                        break;
                    default:
                        var $showMoreRepleaceableElements = $(response).filter('.show-more-replace').html();

                        $('.grid-footer').replaceWith($showMoreRepleaceableElements);
                        break;
                    }
                    pushPermalink();
                    updateSortOptions(response);
                    updateStickySidebarDimensions();
                    editorialVideos.init(); // Initialize video players after ajax call with PLP banner active
                    plugins.restartCarouselBannerPLP(); // Restart carousel banner after ajax call with PLP banner active

                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    }

    handleHistoryStateChange () {
        $(window).on('popstate', function (e) {
            if (!$('.show-more-replace').length) {
                return;
            }

            var loadContentMode = $('.search-results').data('load-content-mode');
            var showMoreUrl = $('.show-more-replace').data('url') + location.search.replace('?', '&');

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: {
                    selectedUrl: showMoreUrl
                },
                method: 'GET',
                success: function (response) {
                    switch (loadContentMode) {
                    case 'pagination':
                        $('.product-grid').empty().html(response);
                        scrollAnimate(null, 0);
                        break;
                    default:
                        var $showMoreRepleaceableElements = $(response).filter('.show-more-replace').html();
                        $('.grid-footer').replaceWith($showMoreRepleaceableElements);
                        break;
                    }
                    updateSortOptions(response);
                    updateStickySidebarDimensions();

                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    }

    applyFilter () {
        // Handle refinement value selection and reset click
        $('body').on(
            'click search:applyFilters',
            '.refinements li button, .refinements li .categoryRefinement, .refinements .remove-microcategory-filters, .mobile-apply-filters-button button.view-all-renderer, .refinements li.filter-value, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                let categorySelected = 0;
                let $currentElement = $(this);
                let stopVeil = true;
                // Get open tabs
                var $openTabs = $('#mobile-refinements .collapse.show');
                var ids = [];
                $openTabs.each((i,el) => {
                    ids.push($(el).attr('id'));
                });


                if (!Breakpoints.is('lgUp') && !$currentElement.hasClass('categoryRefinement') && isMobileCategoryChecked() && isMobileCategoryChecked().length > 0) {
                    categorySelected = 1;
                    stopVeil = false;
                } else if (!Breakpoints.is('lgUp') && $currentElement.hasClass('categoryRefinement') && !$currentElement.find('input').is(':checked')) {
                    categorySelected = 1;
                }

                let urlHref = getRefinementHref($currentElement);

                Breakpoints.is('lgUp') ? $.spinner().start() : $.veil().start();

                $(this).trigger('search:filter', e);
                $.ajax({
                    url: urlHref,
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: urlHref,
                        categorySelected: categorySelected
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response, $currentElement);
                        sendFilterDataGtmEvent(e);

                        if (Breakpoints.is('lgUp')) {
                            scrollAnimate(null, 0);
                            updateStickySidebarDimensions();

                            $.spinner().stop();

                            $('.sticky-sidebar-container .collapse').on('show.bs.collapse', (el) => {
                                // Desktop behavior
                                if (Breakpoints.is('lgUp')) {
                                   closeRefinementsAccordion(el);
                                }
                            });

                        } else {
                            if (stopVeil || $currentElement.hasClass('view-all-renderer')) {
                                scrollAnimate(null, 0);
                                $.spinner().stop();
                            }
                        }
                        // Handle open tabs
                        if($(e.currentTarget).hasClass('attribute-refinement')) {
                            $('#mobile-refinements .microcategoryFilterName').last().closest('.refinement-container').find('.collapse').collapse('hide');
                        }
                        ids.forEach((id) => {
                            $('#mobile-refinements #'+id).collapse('show');
                            $('#mobile-refinements #'+id).addClass('show');
                            $('#desktop-refinement-container #'+id).collapse('show');
                            $('#desktop-refinement-container #'+id).addClass('show');
                        });
                    },
                    error: function () {
                        Breakpoints.is('lgUp') ? $.spinner().stop() : $.veil().stop();
                    }
                });
            });
    }

    applyFilterOnMobileLeave () {
        let lgDown = Breakpoints.get('lgDown');

        lgDown.on('leave', () => {
            if ($('body').hasClass('mobile-filters-selected')) {
                $('.mobile-apply-filters-button button.view-all-renderer').trigger('search:applyFilters');
            }
            $('body').trigger('search:closeMobileRefinements');
        });

    }

    refinementsAccordion () {
        $('.sticky-sidebar-container .collapse').on('show.bs.collapse', (el) => {
            // Desktop behavior
            if (Breakpoints.is('lgUp')) {
               closeRefinementsAccordion(el);
            } else {
                // Mobile behavior
                if ($(el.target).closest('.refinements').length) {
                    el.stopPropagation();
                } else {
                   // $('body').addClass('mobile-refinements-active');
                     closeRefinementsAccordion(el);
                }
            }
        });

        $('[data-target="#mobile-refinements"]').on('click', () => {
            if (!Breakpoints.is('lgUp')) {
                if ($('#mobile-refinements').hasClass('collapse')) {
                    $('body').addClass('mobile-refinements-active');
                } else {
                    $('body').removeClass('mobile-refinements-active');
                }
            }
        });

        $('body').on('click', '[data-target="#mobile-refinements"], [data-target="#mobile-sort-order"]', (e) => {
            mobileAccordionState.push($(e.currentTarget).attr('data-target'));

            if (mobileAccordionState.length >= 2 && mobileAccordionState[mobileAccordionState.length - 1] == mobileAccordionState[mobileAccordionState.length - 2]) {
                $('body').removeClass('mobile-refinements-active');
                mobileAccordionState = [];
            }
        });
    }

    showContentTab () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    }

    get init () {
        return {
            applyFilterOnMobileLeave: this.applyFilterOnMobileLeave(),
            closeMobileRefinements: this.closeMobileRefinements(),
            desktopStickyFilterSidebar: this.desktopStickyFilterSidebar(),
            gtmSendSearchData: this.gtmSendSearchData(),
            gtmSendProductClick: this.gtmSendProductClick(),
            showContentTab: this.showContentTab(),
            showMore: this.showMore(),
            sort: this.sort(),
            applyFilter: this.applyFilter(),
            changeLayout: this.changeLayout(),
            refinementsAccordion: this.refinementsAccordion(),
            desktopFilterSidbarOpen: this.desktopFilterSidbarOpen(),
            desktopFilterSidbarClose: this.desktopFilterSidbarClose(),
            handleHistoryStateChange: this.handleHistoryStateChange()
        };
    }
}

const search = new Search;
export default search;
